/* eslint-disable indent, no-param-reassign,no-plusplus, no-unused-vars */
import download from 'downloadjs';
import axios from 'axios';
import Vue from 'vue';
import uniq from 'lodash/uniq';
import groupBy from 'lodash/groupBy';
import some from 'lodash/some';
import abbreviateNumber from '../../util/abbreviateNumber';
import cacheAxios from '../../util/cacheAxios';

const freshGradSalAxios = axios.create();
const cache = new Map();
cacheAxios(freshGradSalAxios, cache);

freshGradSalAxios.interceptors.response.use(
  response => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      setTimeout(() => {
        window.location.href = '/sign/in?source=/aims';
      }, 500);
    }
  },
);

function getDegreeLbl(lvl) {
  let rlvl = 'Bachelor';
  if (lvl === 'M') {
    rlvl = 'Master';
  }
  return rlvl;
}
function getYear(lbl) {
  return lbl.substring(0, 4);
}
function getFacultyLblgbCty(val) {
  if (!isNaN(val.substring(0, 1))) {
    return val.substring(2, val.length);
  }
  return val;
}
function buildYaxis(lbl = '', gridIndex = 0) {
  const yAxis = {
    splitLine: {
      show: false,
    },
    gridIndex,
    axisLabel: {
      type: 'value',
      formatter: (label) => {
        if (label >= 0) {
          return `${lbl} ${abbreviateNumber(label)}`;
        }
        return `(${lbl} ${abbreviateNumber(-label)})`;
      },
    },
  };
  return yAxis;
}
function buildSeries(
  countries,
  dataCountryCode,
  data,
  index = -1,
  showSymbol = true,
  justUseValue = false,
) {
  const name = countries.find(c => c === dataCountryCode);
  const lineStyle = {
    normal: {
      width: 2,
    },
  };
  // let type = 'line';
  // if (dataCountryCode === userCountryCode) {
  //   lineStyle.normal.width = 5;
  // }
  let dataS;
  if (justUseValue) {
    dataS = data.map(d => [d.year, d.avgSalaryUSD]);
  } else {
    dataS = data.map(d => [d.year, d.avgSalaryUSD]);
  }
  const built = {
    name,
    type: 'line',
    showSymbol,
    lineStyle,
    xAxisIndex: index,
    yAxisIndex: index,
    data: dataS,
  };
  if (index === -1) {
    built.xAxisIndex = 0;
    built.yAxisIndex = 0;
    built.label = {
      normal: {
        show: false,
        formatter: function slb1(params) {
          return `${getFacultyLblgbCty(params.seriesName)}`;
        },
      },
      emphasis: {
        show: true,
        formatter: function slb2(params) {
          return `${getFacultyLblgbCty(params.seriesName)}`;
        },
      },
    };
  }
  return built;
}

const singleGrid = [
  {
    // left: 110,
    right: '12%',
    bottom: '11%',
  },
];
const legend = {
  type: 'scroll',
  bottom: '10%',
  right: '1%',
  orient: 'vertical',
  align: 'right',
};
const dataZoom = [
  {
    type: 'inside',
    show: true,
    realtime: true,
    start: 0,
    end: 100,
  },
  {
    type: 'slider',
    realtime: true,
    start: 60,
    end: 100,
  },
];

export default {
  state: {
    chartLoading: false,
    groupbyViewSelected: 'fac',
    degreelvlFilterSelected: 'B',
    facultySelected: 'Sales',
    allCurrencies: [],
    freshgradFaculty: [],
    freshgradCountry: [],
    degreelvlFilters: [],
    freshgradAll: [],
    fgpCountriesForPlot: [],
    freshGradPayHistoryMap: {},
    filteredFreshGradData: {},
    fgPaychartOptions: {
      title: {
        left: 'center',
        top: '1%',
      },
      backgroundColor: '#fff',
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999',
          },
        },
        padding: [5, 5],
        backgroundColor: '#77a6d8',
        formatter: (params) => {
          let tooltipcustom = '';
          tooltipcustom = tooltipcustom.concat('<div style="font-size:0.9em;text-align:right;">', getYear(params[0].data[0]), '</div>');
          for (let i = 0; i < params.length; i++) {
            tooltipcustom = tooltipcustom.concat('<div><div style="font-size:0.7em;background:', params[i].color, ';width:250px;float:left;">', getFacultyLblgbCty(params[i].seriesName), '</div><div style="font-size:0.7em;float:left;background:', params[i].color, ';width:100px;text-align:right;">US$ ', params[i].value[1].toLocaleString('en'));
            tooltipcustom = tooltipcustom.concat('</div></div>');
          }
          return tooltipcustom;
        },
      },
      toolbox: {
        feature: {
          saveAsImage: {
            show: true,
            title: 'save',
          },
        },
      },
      dataZoom,
      series: [],
      xAxis: [
        {
          type: 'time',
          min: 'dataMin',
          max: 'dataMax',
          data: [],
          splitLine: {
            show: false,
          },
          axisPointer: {
            type: 'shadow',
          },
        },
      ],
      grid: singleGrid,
      legend,
      yAxis: [
        {
          splitLine: {
            show: false,
          },
          axisLabel: {
            type: 'value',
            formatter: (label) => {
              if (label >= 0) {
                return `US$${abbreviateNumber(label)}`;
              }
              return `(US$${abbreviateNumber(-label)})`;
            },
          },
        },
      ],
    },
  },
  mutations: {
    setGroupbyView(state, dview) {
      state.fgpCountriesForPlot = [];
      state.groupbyViewSelected = dview;
    },
    setCurrencies(state, allCurrencies) {
      state.allCurrencies = allCurrencies;
    },
    setFreshGrads(state, allData) {
      state.freshgradAll = allData;
    },
    setFaculty(state, facData) {
      state.freshgradFaculty = facData;
    },
    setCountry(state, cData) {
      state.freshgradCountry = cData;
    },
    setDegreeLvl(state, dlvlData) {
      state.degreelvlFilters = dlvlData;
    },
    setFilteredFreshGradData(state, sData) {
      state.filteredFreshGradData = sData;
    },
    setChartLoading(state, loading) {
      state.chartLoading = loading;
    },
    addSelfFreshGradPayHistoryMap(state, map) {
      Object.keys(map)
        .forEach((k) => {
          Vue.set(state.selfFreshGradPayHistoryMap, k, map[k]);
        });
    },
    addFreshGradPayHistoryMap(state, maps) {
      Object.keys(maps)
        .forEach((k) => {
          Vue.set(state.freshGradPayHistoryMap, k, maps[k]);
        });
    },
    setFacultySelected(state, indicator) {
      state.fgpCountriesForPlot = [];
      state.facultySelected = indicator;
    },
    setDegreelvlFilterSelected(state, indicator) {
      state.degreelvlFilterSelected = indicator;
    },
    removeGradPayForPlot(state, countries) {
      state.fgpCountriesForPlot = state.fgpCountriesForPlot.filter(
        c => !countries.find(cc => cc === c),
      );
    },
    appendGradPayForPlot(state, countries) {
      countries.forEach((c) => {
        if (!state.fgpCountriesForPlot.some(v => c === v) && c !== undefined) {
          state.fgpCountriesForPlot.push(c);
        }
      });
    },
    fgpPlotSingleChart(state, val) {
      const title = {
        ...state.fgPaychartOptions.title,
        text: val.title,
        top: '1%',
        left: 'center',
      };
      const xAxis = {
        ...state.fgPaychartOptions.xAxis,
        data: val.xAxisData,
        axisLabel: {
          formatter: function gy(value, index) {
            return `${getYear(value)}`;
          },
        },
        axisPointer: {
          label: {
            formatter: function gyp(params) {
              return `${getYear(params.value)}`;
            },
          },
        },
      };
      const series = val.series;
      const legendSingle = {
        ...legend,
        data: val.legendData,
        formatter: function lg(name) {
          return `${getFacultyLblgbCty(name)}`;
        },
        bottom: '100px',
      };
      state.fgPaychartOptions = {
        ...state.fgPaychartOptions,
        title,
        xAxis,
        grid: singleGrid,
        yAxis: val.yAxis,
        legend: legendSingle,
        dataZoom,
        series,
        clear: true,
      };
    },
  },
  actions: {
    getFreshGradPayHistoryMap({
      state,
      commit,
      dispatch,
    }, countries) {
      commit('setChartLoading', true);
      let indicators = {};
      if (state.groupbyViewSelected === 'cty') {
        indicators = countries
          .filter(
            c =>
            !(`${state.facultySelected}${state.degreelvlFilterSelected}${c}` in
              state.freshGradPayHistoryMap),
          )
          .map(c => `${state.facultySelected}${state.degreelvlFilterSelected}${c}`);
      } else {
        indicators = countries
          .filter(
            c =>
            !(`${c}${state.degreelvlFilterSelected}${state.facultySelected}` in
              state.freshGradPayHistoryMap),
          )
          .map(c => `${c}${state.degreelvlFilterSelected}${state.facultySelected}`);
      }
      if (indicators.length > 0) {
        freshGradSalAxios.post('/aims/api/freshGradSal/graphdata', indicators)
        .then((res) => {
          if (res.data) {
            commit('setFilteredFreshGradData', res.data);
            commit('addFreshGradPayHistoryMap', res.data);
            dispatch('fgpPrepareSingleChart', countries);
          }
        });
      } else {
        dispatch('fgpPrepareSingleChart', countries);
      }
    },
    fgpPrepareSingleChart({
      state,
      rootState,
      commit,
    }, countries) {
      const userCountry = rootState.currentUserCountry;
      let xAxisData = [];
      let series = [];
      let yAxis;
      let indicators = {};
      if (state.groupbyViewSelected === 'cty') {
        indicators = countries
          .map(c => ({
            country: c,
            indicators: state.freshGradPayHistoryMap[
              `${state.facultySelected}${state.degreelvlFilterSelected}${c}`
              ] || [],
          }))
          .filter(c => c.indicators.length > 0);
      } else {
        indicators = countries
          .map(c => ({
            country: c,
            indicators: state.freshGradPayHistoryMap[
              `${c}${state.degreelvlFilterSelected}${state.facultySelected}`
              ] || [],
          }))
          .filter(c => c.indicators.length > 0);
      }
      if (indicators.length > 0) {
        if (indicators[0].indicators.length > 0) {
          let lbl = '';
          if ('avgSalary' in indicators[0].indicators[0]) {
            lbl = 'US$';
          }
          yAxis = buildYaxis(lbl);
        }
      }
      if (!yAxis) {
        yAxis = buildYaxis();
      }
      indicators.forEach((i) => {
        i.indicators.forEach((id) => {
          xAxisData.push(id.year);
        });
      });
      xAxisData = uniq(xAxisData)
        .sort();
      series = indicators.map(i =>
        buildSeries(
          state.fgpCountriesForPlot,
          i.country,
          i.indicators,
        ),
      );
      const legendData = series.map(s => s.name);
      commit('fgpPlotSingleChart', {
        title: `${getFacultyLblgbCty(state.facultySelected)} (${getDegreeLbl(state.degreelvlFilterSelected)})`,
        xAxisData,
        series,
        legendData,
        yAxis,
      });
      commit('setChartLoading', false);
    },
    postFeedback(_ctx, feedback) {
      return freshGradSalAxios.post('/aims/api/freshGradSal/feedback', feedback)
        .then((res) => {
          if (res.status !== 200) {
            throw Error('Fail to save Feedback');
          }
          return true;
        });
    },
    getfreshgradSalary({
      commit,
    }) {
      freshGradSalAxios.get('/aims/api/freshGradSal/faculties')
        .then((res) => {
          if (res.data) {
            commit('setFaculty', res.data);
          }
        });
      freshGradSalAxios.get('/aims/api/freshGradSal/countries')
        .then((res) => {
          if (res.data) {
            commit('setCountry', res.data);
          }
        });
      freshGradSalAxios.get('/aims/api/freshGradSal/degreelvl')
        .then((res) => {
          if (res.data) {
            commit('setDegreeLvl', res.data);
          }
        });
      freshGradSalAxios.post('/aims/api/freshGradSal/all')
        .then((res) => {
          if (res.data) {
            commit('setFreshGrads', res.data);
          }
        });
      freshGradSalAxios.post('/aims/api/freshGradSal/currencies')
        .then((res) => {
          if (res.data) {
            commit('setCurrencies', res.data);
          }
        });
    },
    exportfreshgradSalary({ commit }, data) {
      // freshGradSalAxios.post('/aims/api/freshGradSal/export/all', {
      //   responseType: 'blob',
      // })
      //   .then((res) => {
      //     if (res.status === 200) {
      //       download(res.data, 'MRC Graduate Start Rates Report.xlsx',
      // 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
      //     }
      //   });
      fetch('/aims/api/freshGradSal/export/all', {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        redirect: 'follow',
        body: JSON.stringify(data),
      })
        .then(async (response) => {
          if (response.ok) {
            return response;
          }
          if (response.status === 401) {
            const src = window.location.pathname + window.location.search + window.location.hash;
            window.location.href = `/sign/in?source=${src}`;
          }
          const errMsg = await response.json();
          if (errMsg) {
            throw new Error(errMsg);
          }
          throw new Error(`${response.statusText} : ${response.status}`);
        })
        .then((resp) => {
          if (resp.ok) {
            return resp.blob();
          }
          return resp.data;
        })
        .then((blob) => {
          download(blob, 'MRC Graduate Start Rates Report.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        })
        .catch(err => console.error(err));
    },
  },
  getters: {
    degreelvlFilter(state) {
      return state.degreelvlFilters;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/freshGradSalModule.js